import React, { memo } from 'react';

const ChekmarkInner = () => (
    <svg viewBox="0 0 13 10">
        <path d="M4.59102 9.49996C4.42165 9.50075 4.25879 9.43415 4.13776 9.31462L0.169782 5.30871C-0.0639472 5.05134 -0.0553375 4.65393 0.189314 4.4071C0.433966 4.16028 0.827887 4.15159 1.08299 4.3874L4.59102 7.92655L11.7438 0.711598C11.9044 0.534808 12.1482 0.461169 12.3786 0.519846C12.609 0.578523 12.789 0.760049 12.8471 0.99253C12.9053 1.22501 12.8323 1.47094 12.6571 1.63292L5.04829 9.31462C4.92627 9.43515 4.76178 9.50182 4.59102 9.49996Z" />
    </svg>
);

export const Chekmark = memo(ChekmarkInner);
